import { Action, State } from "store/store";

export const focusBlock = (state: State, { data }: Action): State => {
  const { focusedNodeId, lastFocusedNodeId, currentInteractionBlockId } = state;

  const type = data && (state.blocks as any)[data.id].type;
  let updatedCurrentInteractionBlockId =
    type && type === 'Interaction'
      ? data.id
      : !data || data.id === null
        ? null
        : currentInteractionBlockId;

  return {
    ...state,
    lastFocusedNodeId: lastFocusedNodeId === '' ? data.id : focusedNodeId,
    focusedNodeId: data ? data.id : null,
    currentInteractionBlockId: updatedCurrentInteractionBlockId,
  };
};
